import React from 'react';
import { showConfirmation } from '@components/Confirmation';
import { addToast } from '@components/Toaster';

import { DeleteButtonProps } from './types';

export const DeleteButton: React.FC<DeleteButtonProps> = ({
    id,
    onDelete,
    isLoading,
    variant,
    size,
    label,
    className,
    type,
    onDeleteSuccess,
    currentStatus,
}) => {
    const handleDelete = () => {
        showConfirmation({
            title: 'Delete',
            html:
                currentStatus === true ? (
                    <span>Are you sure you want to unarchive this item?</span>
                ) : (
                    <span>Are you sure you want to delete this item?</span>
                ),
            onConfirm: async () => {
                if (onDelete) {
                    const { response } = await onDelete(id);
                    if (response && response.data) {
                        addToast({ message: 'Item updated/deleted successfully', variant: 'success' });
                        onDeleteSuccess && onDeleteSuccess(id);
                    }
                }
            },
        });
    };

    return type === 'icon' ? (
        <i className={`fa fa-trash ${className || ''}`} onClick={handleDelete} style={{ cursor: 'pointer' }} />
    ) : (
        <button
            className={`btn btn-${variant || 'danger'} ${size ? `btn-${size}` : ''} ${className || ''}`}
            onClick={handleDelete}
            disabled={isLoading}
        >
            {isLoading ? 'Please wait...' : label || 'Delete'}
        </button>
    );
};
